import { BUILD_ID } from "@/modules/env/constants"

export function isNextDataUrlOrPathname(url: string): boolean {
  const { pathname } = new URL(url, "http://localhost")

  return pathname.startsWith(`/_next/data/${BUILD_ID}/`)
}
